/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.reports.bgvtracker', {
      url: '/bgvtracker?bucket',
      template: '<bgvtracker></bgvtracker>',
      params: {
        bucket: { value: 'BGV_TRACKER' },
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/reports/bgvTracker/bgvTracker.routes.js